// extracted by mini-css-extract-plugin
export default {"wrap":"MenuCategoriesListComponent_wrap__1gfn3"};